// extracted by mini-css-extract-plugin
export default {"spinner":"Loading_spinner__pKZeL","spin":"Loading_spin__ULZKE"};